export default {
  // shared functionality unique to inline widgets can go here
};
